document.addEventListener('DOMContentLoaded', function() {
  const allMenuTriggers = document.querySelectorAll('summary[aria-controls^="MegaMenu-"]');
  const allDetailsElements = Array.from(allMenuTriggers).map(trigger => trigger.closest('details'));

  allMenuTriggers.forEach(summaryElement => {
    // --- FIX 1: Timers moved inside the loop ---
    // Each menu item now gets its own independent timers.
    let openTimeout;
    let closeTimeout;

    const detailsElement = summaryElement.closest('details');
    const dropdownPanelId = summaryElement.getAttribute('aria-controls');
    const dropdownPanel = document.getElementById(dropdownPanelId);

    if (detailsElement && dropdownPanel) {

      detailsElement.addEventListener('mouseenter', function() {
        clearTimeout(closeTimeout);
        openTimeout = setTimeout(() => {
          allDetailsElements.forEach(otherDetails => {
            if (otherDetails && otherDetails !== detailsElement) {
              otherDetails.removeAttribute('open');
            }
          });
          detailsElement.setAttribute('open', '');
        }, 200);
      });

      detailsElement.addEventListener('mouseleave', function() {
        clearTimeout(openTimeout);
        // --- FIX 2: Close delay restored to 300ms ---
        closeTimeout = setTimeout(() => {
          detailsElement.removeAttribute('open');
        }, 300);
      });

      dropdownPanel.addEventListener('mouseenter', function() {
        clearTimeout(closeTimeout);
      });

      dropdownPanel.addEventListener('mouseleave', function() {
        // --- FIX 2: Close delay restored to 300ms ---
        closeTimeout = setTimeout(() => {
          detailsElement.removeAttribute('open');
        }, 300);
      });

      detailsElement.addEventListener('focusout', function(event) {
        if (detailsElement.contains(event.relatedTarget)) return;
        clearTimeout(openTimeout);
        detailsElement.removeAttribute('open');
      });
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    const openDetails = allDetailsElements.find(details => details && details.hasAttribute('open'));
    if (!openDetails) return;
    openDetails.removeAttribute('open');
    const trigger = openDetails.querySelector('summary');
    if (trigger) trigger.focus();
  });
});